[
  {
    "name": "French",
    "local": "Français",
    "code": "fr"
  },
  {
    "name": "English",
    "local": "English",
    "code": "en"
  },
  {
    "name": "Spanish",
    "local": "Español",
    "code": "sp"
  },
  {
    "name": "German",
    "local": "Deutsch",
    "code": "de"
  },
  {
    "name": "Chinese",
    "local": "中文, zhōngwén",
    "code": "zh"
  },
  {
    "name": "Russian",
    "local": "Pусский",
    "code": "ru"
  }
]
